export const disabledVisual = {
  cursor: 'default',
  opacity: 'disabled',
};
